var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8.71584C20.5 7.65275 19.9374 6.66904 19.0211 6.13004L13.5211 2.89474C12.5822 2.34248 11.4178 2.34248 10.4789 2.89474L4.97894 6.13004C4.06262 6.66904 3.5 7.65275 3.5 8.71584V15.2842C3.5 16.3473 4.06262 17.331 4.97894 17.87L10.4789 21.1053C11.4178 21.6575 12.5822 21.6575 13.5211 21.1053L19.0211 17.87C19.9374 17.331 20.5 16.3473 20.5 15.2842V8.71584Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V15M16 9V15M8 13V15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeed1);
export default __webpack_public_path__ + "static/media/need-1.b3b053734b8f2439b2669211ca9f15dd.svg";
export { ForwardRef as ReactComponent };